import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { useLang } from "@/App";
import { Reveal, ChapterHead } from "@/components/Section";

const Manifesto = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(0);

  return (
    <section id="manifeste" data-testid="manifesto-section" className="relative px-5 md:px-10 py-28 md:py-40 bg-inkdeep scroll-mt-20">
      <div className="max-w-[1600px] mx-auto">
        <ChapterHead kicker={t.manifesto.kicker} title={t.manifesto.title} dark testId="manifesto" />

        <div data-testid="manifesto-accordion-container" className="border-t border-linedark">
          {t.manifesto.chapters.map((c, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="border-b border-linedark">
                <button
                  data-testid={`manifesto-chapter-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center gap-6 md:gap-12 py-8 md:py-10 text-left group"
                >
                  <span className="font-display italic text-3xl md:text-5xl text-gold/70 w-14 md:w-20 shrink-0">{c.n}</span>
                  <h3 className={`font-display font-light text-3xl md:text-5xl flex-1 leading-tight transition-colors ${isOpen ? "text-paper" : "text-paper/50 group-hover:text-paper/80"}`}>
                    {c.title}
                  </h3>
                  <motion.span animate={{ rotate: isOpen ? 45 : 0 }} transition={{ duration: 0.4 }} className="text-gold shrink-0">
                    <Plus size={22} />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p data-testid={`manifesto-text-${i}`} className="pl-[80px] md:pl-[128px] pr-6 pb-10 max-w-3xl font-display text-xl md:text-2xl leading-relaxed text-paper/70">
                        {c.text}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>

        <Reveal delay={0.2} className="mt-16">
          <p className="font-display italic text-2xl md:text-3xl text-gold/80 max-w-2xl leading-snug">
            « Saint Léonard, donne-nous de voir les liens qui nous enchaînent et les relations qui nous libèrent. »
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Manifesto;
